import Translation from 'lib/helpers/translation';

const ferryHomeTranslations = {
  ...Translation.group('ferryHome')
};

const searchMaskTranslations = {
  ...Translation.group('searchMask')
};

const ferryHeroTranslations = {
  ...Translation.group('hero')
};

const ferryDealsTranslations = {
  ...Translation.group('deals')
};

const ferryCompaniesTranslations = {
  ...Translation.group('companies')
};

const ferryPartnerTranslations = {
  ...Translation.group('ferryPartner')
};

const ferryResults = {
  ...Translation.group('ferryResults')
};

const ferrySeating = {
  ...Translation.group('ferrySeating')
};

const ferryPayment = {
  ...Translation.group('ferryPayment')
};

const ferryConfirmation = {
  ...Translation.group('ferryConfirmation')
};

const resultModelTranslations = {
  ...Translation.group('resultModel')
};

const expirationPopupTranslations = {
  ...Translation.group('expirationPopup')
};

export {
  ferryHomeTranslations,
  searchMaskTranslations,
  ferryHeroTranslations,
  ferryDealsTranslations,
  ferryCompaniesTranslations,
  ferryPartnerTranslations,
  ferryResults,
  ferrySeating,
  ferryPayment,
  ferryConfirmation,
  resultModelTranslations,
  expirationPopupTranslations
};